<template>
  <router-view></router-view>
</template>

<script>
  import {bus} from "@/main";
  import { removeSession,keepAdminAlive } from "@/_services/authentication.service";


  export default {
    name: "app",
    data(){
      return{
        sessionInterval:null
      }
    },
    methods:{
      keepAlive(timeout){
        let timeTrigger=timeout
        if(timeout>60000){
          timeTrigger=timeout-60000
        }else {
          timeTrigger=timeout-30000
        }
        this.sessionInterval = setInterval(function () {
          keepAdminAlive()
        },timeTrigger)
      }
    },
    mounted() {
      this.$Message.config({
        top: 65,
        duration: 5
      });
      this.$Notice.config({
        top: 65,
        duration: 3
      });
      // bus.$on('sessionExpired', () => {
      //   removeSession();
      //   this.$router.push({ name: "Login" });
      // });
      bus.$on('requestError', (err) => {
        if (err.response.status == 403) {
          removeSession();
          this.$router.push({ name: "Login" });
          this.$Message.error("Session Expired.")
        }
        if(err.response.status==401){
          removeSession();
          this.$router.push({ name: "Login" });
          this.$Message.error("User currently banned from using the application due to multiple failed request.")
        }

      });
      bus.$on('sessionTimeoutChanged', (timeout) => {
        clearInterval(this.sessionInterval);
        this.keepAlive(timeout)
      });
    }
  };
</script>

<style></style>
